import { factory } from './app';

factory('ValidationService', [
  '$http',
  function($http) {
    return {
      validateAddress: validateAddress,
      validateTaxAddress: validateTaxAddress
    };

    function validateAddress(address) {
      var options = {
        method: 'POST',
        url: '/validate/address/',
        data: {
          address: address
        }
      };

      return $http(options);
    }

    function validateTaxAddress(addresses) {
      var options = {
        method: 'POST',
        url: '/validate/tax-address/',
        data: {
          addresses: addresses
        }
      };

      return $http(options);
    }
  }
]);
